import { render, staticRenderFns } from "./CreateTestType.vue?vue&type=template&id=8e7b9a0a&"
import script from "./CreateTestType.vue?vue&type=script&lang=js&"
export * from "./CreateTestType.vue?vue&type=script&lang=js&"
import style0 from "./CreateTestType.vue?vue&type=style&index=0&id=8e7b9a0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports